import { createContext, useContext, useState } from "react";

import { Toaster } from "@skydio/rivet-ui";

import type { ReactNode } from "react";

type ToastContext = {
  setAppToasterEnabled: (enabled: boolean) => void;
};

const toastContext = createContext<ToastContext>({
  setAppToasterEnabled: () => {},
});

export const useSetAppToasterEnabled = () => {
  const { setAppToasterEnabled } = useContext(toastContext);

  return setAppToasterEnabled;
};

export default function ToastProvider({ children }: { children: ReactNode }) {
  const [appToasterEnabled, setAppToasterEnabled] = useState(true);

  return (
    <toastContext.Provider value={{ setAppToasterEnabled }}>
      {appToasterEnabled && <Toaster />}
      {children}
    </toastContext.Provider>
  );
}
